import GLOBAL from './global';

class Logging {

  constructor(props) {
    this.LogRecords = [];
    this.url = GLOBAL.VARIABLES.LOGGINGAPIURL;
    this.responseBody = {};
    this.tokenExpireTime = new Date();
    // this.interval = setInterval(function() {this.UploadLog()}.bind(this), GLOBAL.CONFIGSETTINGS.LogSetting.UPLOAD_LOG_DURATION);
    // this.state = { hasLocationPermission: false }
  }

  // LogBodyInput can insert values, else default and autofill memebers
  async setRequired(logBodyInput, type) {

    ////console.log(logBodyInput);

    // Create a fresh logBody to lock allowed fields
    let logBody = {}
    logBody.EventTypeId = type;

    // Check input log fields, only allow these fields below, default where missing
    if (logBodyInput.EventMessage) {
      if (logBodyInput.EventMessage.text !== null && logBodyInput.EventMessage.text !== undefined) {
        logBody.EventMessage = logBodyInput.EventMessage.text;
      }
      else {
        logBody.EventMessage = logBodyInput.EventMessage;
      }
    }
    else
      logBody.EventMessage = type + " method called at time: " + new Date().valueOf();

    if (!logBodyInput.EventLevelId) {

      switch (type) {
        case "Debug":
          logBody.EventLevelId = 100;
          break;
        case "Info":
          logBody.EventLevelId = 80;
          break;
        case "Warning":
          logBody.EventLevelId = 50;
          break;
        case "Error":
          logBody.EventLevelId = 40;
          break;
        case "Event":
          logBody.EventLevelId = 0;  // Events should always be logged
          break;
        default:
          logBody.EventLevelId = "level";
      }
    }

    if (logBodyInput.EventCategory)
      logBody.EventCategory = logBodyInput.EventCategory;
    else
      logBody.EventCategory = type;

    logBody.LogName = GLOBAL.VARIABLES.LOG_NAME;
    logBody.ClientLogId = new Date().valueOf();
    logBody.UTCOffset = new Date().getTimezoneOffset();

    if (GLOBAL.CONFIGSETTINGS.LogSetting.LOG_ENABLED) {
      this.LogRecords.push(logBody);
      this.UploadLog();
    }
  }

  Debug(logBody) {
    if ((GLOBAL.CONFIGSETTINGS.LogSetting.LOG_LEVEL === -1 || GLOBAL.CONFIGSETTINGS.LogSetting.LOG_LEVEL === 100)) {
      this.setRequired(logBody, "Debug");
    }
  }
  Error(logBody) {
    if (GLOBAL.CONFIGSETTINGS.LogSetting.LOG_LEVEL === -1 || GLOBAL.CONFIGSETTINGS.LogSetting.LOG_LEVEL >= 40) {
      this.setRequired(logBody, "Error");
    }
  }
  Info(logBody) {
    if (GLOBAL.CONFIGSETTINGS.LogSetting.LOG_LEVEL === -1 || GLOBAL.CONFIGSETTINGS.LogSetting.LOG_LEVEL >= 80) {
      this.setRequired(logBody, "Info");
    }
  }
  Warning(logBody) {
    if (GLOBAL.CONFIGSETTINGS.LogSetting.LOG_LEVEL === -1 || GLOBAL.CONFIGSETTINGS.LogSetting.LOG_LEVEL >= 50) {
      this.setRequired(logBody, "Warning");
    }
  }
  Event(logBody) {
    if (GLOBAL.CONFIGSETTINGS.LogSetting.LOG_LEVEL === -1 || GLOBAL.CONFIGSETTINGS.LogSetting.LOG_LEVEL >= 0) {
      this.setRequired(logBody, "Event");
    }
  }

  // Trace is gets called automatically whenever a traced Component is mounted or unmounted
  async Trace(componentName, category, mountOrUnmount) {

    // Location information - attached to all traced events

    let logBody = {
      "EventTypeId": "Trace",
      "EventLevelId": 100,
      "EventCategory": category,
      "EventMessage": "Component " + mountOrUnmount + ": " + componentName,
      "LogName": GLOBAL.VARIABLES.LOG_NAME,
      "ClientLogId": new Date().valueOf(),
    };
    if (GLOBAL.CONFIGSETTINGS.LogSetting.LOG_ENABLED) {
      this.LogRecords.push(logBody);
    }
  }

  GetToken() {
    try {
      let details = {
        'username': GLOBAL.VARIABLES.LOGGING_USERNAME,
        'password': GLOBAL.VARIABLES.LOGGING_PASSWORD,
        'grant_type': 'password'
      };

      let requestBody = [];
      for (let property in details) {
        let encodedKey = encodeURIComponent(property);
        let encodedValue = encodeURIComponent(details[property]);
        requestBody.push(encodedKey + "=" + encodedValue);
      }

      requestBody = requestBody.join("&");
      let p = new XMLHttpRequest();
      p.open('post', this.url + "/token", true);
      p.setRequestHeader("Accept", "application/json");
      p.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

      try {
        p.onload = () => {
          if (p.status === 200) {
            const data = JSON.parse(p.responseText);
            this.responseBody = data;
            this.tokenExpireTime = new Date(Date.now());
            this.tokenExpireTime.setSeconds(this.tokenExpireTime.getSeconds() + this.responseBody.expires_in);
            this.UploadLog();
          }
          else {
            //console.log("Status did not return 200. logging.js")
          }
        }
        p.onerror = () => { }
      }
      catch (e) {
        //console.log(e);
      }

      p.send(requestBody);
    }
    catch (e) {
      //This is when the request times out, it will say Unexpected token < at JSON at position 0 
      //TODO: Deal with this and other errors. 
      //console.log(e);
    }
  }

  UploadLog() {
    if (this.LogRecords.length === 0) {
      return;
    }
    else {
      // Get token first before trying to upload log
      if (!this.responseBody.access_token || this.tokenExpireTime < Date.now()) {
        this.GetToken();
      }
      // Because of aync behavior this needs to not run if there isn't a token yet
      else {
        try {
          this.LogRecords.forEach((l) => {
            //console.log(l);
            let log = new XMLHttpRequest();
            log.open('POST', this.url + '/api/log', true);
            log.setRequestHeader("Accept", "application/json");
            log.setRequestHeader("Content-type", "Application/json");
            log.setRequestHeader("Authorization", "Bearer " + this.responseBody.access_token);
            log.onload = () => {
              if (log.status === 200) {
                const logData = JSON.parse(log.responseText);
                this.removeLog(logData.ClientLogId);
              }
              else {
                //TODO: Do something with errors.
              }
            }
            log.onerror = () => { }
            log.send(JSON.stringify(l));
          });
        }
        catch (e) {
          //Same reason as with the token
          //TODO: deal with errors
          //console.log(e);
        }

      }
    }
  }

  removeLog(LogId) {
    let index;
    let breakObject = "Found ClientLogId";
    try {
      this.LogRecords.forEach((log, i) => {
        if (log.ClientLogId === LogId) {
          index = i;

          // No need to keep going through array if we found the right one
          throw (breakObject);
        }
      });
    }
    catch (e) {
      if (e === "Found ClientLogId") {
        this.LogRecords.splice(index, 1);
      }
    }
  }
}
//r-18-lint-dj
//eslint-disable-next-line
export default new Logging();